import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Stack, Typography } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

import { BookNowButton } from "components/Carrier/components/BookNowButton";
import { EvotruxDivider } from "components/EvotruxDivider";

interface CarrierBookNowProps {
  shipment: CarrierCondensedShipment | undefined;
  sectionHeaderType: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  sectionSpace: string;
}

export function CarrierBookNow(props: CarrierBookNowProps) {
  const { shipment, sectionHeaderType, sectionSpace } = props;

  if (
    !shipment?.book_now_info?.is_book_now ||
    shipment.shipment_status !== "ACTIVE" ||
    !shipment.is_partner_shipment ||
    shipment.info.type !== "SINGLE"
  ) {
    return null;
  }

  return (
    <>
      <Stack
        id="book-now-section"
        direction="row"
        mt={sectionSpace}
        alignItems="center"
        spacing={1}
      >
        <Typography variant={sectionHeaderType}>Book Now</Typography>
        <Tooltip
          title={
            <Typography variant="h5">
              You can instantly book this load for the price listed below,
              skipping the quoting process. If the price/equipment doesn&apos;t
              work for you, please submit a quote.
            </Typography>
          }
        >
          <InfoOutlinedIcon color="primary" fontSize="large" />
        </Tooltip>
      </Stack>
      <EvotruxDivider />
      <BookNowButton shipment={shipment} />
    </>
  );
}
